import { __decorate } from "tslib";
import { html, observable, slotted } from '@microsoft/fast-element';
import { ChameleonElementMixin } from '../common/mixin';
import { FoundationElement } from '@microsoft/fast-foundation';
export const topBarTemplate = html ` <div class="container">
  <div class="logo">
    <slot name="logo" ${slotted('logoNodes')}></slot>
  </div>
  <div class="submenu">
    <slot name="submenu" ${slotted('submenuNodes')}></slot>
  </div>
  <div class="search-container">
    <slot name="search-field"></slot>
  </div>
  <div class="extra-element-container">
    <slot name="extra-element-container"></slot>
  </div>
  <div class="button-container">
    <slot name="button-container"></slot>
  </div>
  <div class="sign-in-container">
    <slot name="sign-in-button"></slot>
  </div>
</div>`;
export class TopBarComponent extends ChameleonElementMixin(FoundationElement) {
    connectedCallback() {
        super.connectedCallback();
        this.setSeparator();
    }
    logoNodesChanged() {
        var _a, _b;
        if (this.logoNodes && this.logoNodes.length > 0) {
            const logoNode = this.logoNodes[0];
            if (logoNode && logoNode instanceof Element && !((_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.separator'))) {
                this.setSeparator();
            }
        }
        else if ((_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('.separator')) {
            this.removeSeparator();
        }
    }
    submenuNodesChanged() {
        var _a, _b;
        if (this.submenuNodes && this.submenuNodes.length > 0) {
            const submenuNode = this.submenuNodes[0];
            if (submenuNode && submenuNode instanceof Element && !((_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.separator'))) {
                this.setSeparator();
            }
        }
        else if ((_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('.separator')) {
            this.removeSeparator();
        }
    }
    setSeparator() {
        var _a, _b;
        const separator = document.createElement('div');
        separator.setAttribute('class', 'separator');
        (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.logo')) === null || _b === void 0 ? void 0 : _b.appendChild(separator);
    }
    removeSeparator() {
        var _a, _b;
        (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.separator')) === null || _b === void 0 ? void 0 : _b.remove();
    }
}
__decorate([
    observable
], TopBarComponent.prototype, "logoNodes", void 0);
__decorate([
    observable
], TopBarComponent.prototype, "submenuNodes", void 0);
